import { render, staticRenderFns } from "./CustomerPricesAtacarejo.vue?vue&type=template&id=ee711750"
import script from "./CustomerPricesAtacarejo.vue?vue&type=script&lang=js"
export * from "./CustomerPricesAtacarejo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports